import React from "react";
import { heroFeatures, images, product } from "../data/product";
import { CtaButton } from "./ui/CtaButton";
import { Disclosure } from "./ui/Disclosure";
import { ImageSlot } from "./ui/ImageSlot";
export function Hero() {
  return <section id="top" className="bg-cream pb-12 lg:py-16" data-id="element-111" data-mp="9lbeyxpzr5c0">
      <div className="mx-auto grid max-w-6xl lg:grid-cols-2 lg:items-start lg:gap-14 lg:px-6" data-id="element-112" data-mp="4m8kg77n0hia">
        <div className="lg:sticky lg:top-24" data-id="element-113" data-mp="12a0kd8y2xwtk">
          <ImageSlot src={images.heroBundle} alt="Il pacchetto di ricette Belnestore Sostenibile con bonus e cosmetici naturali fatti in casa" placeholderLabel="Mockup principale del pacchetto" className="aspect-[4/3] w-full shadow-[0_18px_40px_-24px_rgba(86,18,54,0.45)] lg:rounded-[28px]" data-id="element-114" data-mp="128pijeo72z53" />
        </div>

        <div className="px-4 pt-7 sm:px-6 lg:px-0 lg:pt-2" data-id="element-115" data-mp="3d1sa6w93nhsl">
          <h1 className="font-serif text-[32px] font-semibold leading-[1.1] text-wine sm:text-[42px] lg:text-[50px]" data-id="element-116" data-mp="382ff5o82r4ex">
            Tutta la tua routine per il corpo,
            <span className="block italic text-rose" data-id="element-117" data-mp="3j9283w7ie4z8">fatta in casa al naturale</span>
          </h1>
          <p className="mt-5 text-[17px] leading-relaxed text-ink sm:text-lg" data-id="element-118" data-mp="3o73qeex4209n">
            <strong className="font-semibold text-wine" data-id="element-119" data-mp="399bctsb4jly3">600+ ricette DIY</strong>: burri, oli, saponi, scrub,
            deodoranti e molto altro — con{" "}
            <strong className="font-semibold text-wine" data-id="element-120" data-mp="30i19j9aawbg7">grammi esatti, percentuali reali e durata</strong> su ogni
            pagina. Niente “un cucchiaio di questo e una tazza di quello”.
          </p>

          <div className="mt-6 border-t border-line" data-id="element-121" data-mp="2qk3kwkoj4cn2">
            {heroFeatures.map(f => <Disclosure key={f.title} title={f.title} data-id="element-122" data-mp="2viy4vpy8g78r">
                {f.body}
              </Disclosure>)}
          </div>

          <div className="mt-8 flex flex-col items-center sm:items-start" data-id="element-123" data-mp="2hk87sabey7ke">
            <CtaButton data-id="element-124" data-mp="2lla4ajdy45io">Ottieni le {product.recipes} ricette</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}